import {ActionReducerMap, MetaReducer} from "@ngrx/store";
import * as SmartvusReducer from './smartvus/smartvus.reducer';
import {State} from './core.state';

export const reducers: ActionReducerMap<State> = {
    smartvus: SmartvusReducer.reducer,
};

export const metaReducers: MetaReducer<State>[] = [];
